import SegmentSingleMob from './SegmentSingleMob';
export default SegmentSingleMob;
